// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZXZe","title":"styles_title__2sgsw"};